import React from "react";
import {
  getLoanInstallmentTotalInterest,
  getLoanInstallmentTotalPrincipal,
} from "../../../utils/loan";
import InstallmentRow from "./InstallmentRow";
import styles from "./style.module.css";
import { useTranslation } from "react-i18next";

const InstallmentTable = ({ installments, totalInstallmentAmount }) => {
  const totalInterest = getLoanInstallmentTotalInterest(installments);
  const { t } = useTranslation("myLoanItem");
  const totalPrincipal = getLoanInstallmentTotalPrincipal(installments);

  const header = [
    t("period"),
    t("status"),
    t("paidPerPeriod"),
    t("paidInterest"),
    t("paidPrinciple"),
    t("remainPrinciple"),
  ];

  return (
    <div style={{ overflowX: "auto" }}>
      <table className={styles.table}>
        <thead>
          <tr>
            {header.map((h) => (
              <th className={styles.header}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {installments.map((installment, index) => (
            <InstallmentRow
              key={installment.installment_id}
              installment={installment}
              installmentTitle={index + 1}
              openingBalance={installments?.[index + 1]?.openning_balance}
            />
          ))}
          <InstallmentRow
            key={installments.length}
            installment={{
              total_amount: null,
              interest: totalInterest,
              principal: totalPrincipal,
            }}
            installmentTitle={t("sum")}
            openingBalance={null}
          />
        </tbody>
      </table>
    </div>
  );
};

export default InstallmentTable;
